import React from 'react';
import { Wrapper, Avatar, InputButton, Icon, Input } from './elements';
import { useText } from 'common/hooks';

function AcAvatar(props) {
  const t = useText();
  const profile = props.profile || {};
  const hasAvatar = Boolean(
    profile?.avatarImage || profile?.public?.avatarImage
  );
  const icon = hasAvatar ? 'icon-delete' : 'icon-photo_camera';

  return (
    <Wrapper className={props.className}>
      <Input
        onChange={props.onAddAvatar}
        type="file"
        name="file"
        id="file"
        aria-label={t('account.settings.profile.general_info.update_picture')}
      />
      <Avatar
        isLoading={props.isLoading}
        onClick={props.onClick}
        image={props.image}
      />
      {!props.isLoading && hasAvatar && (
        <InputButton>
          <Icon onClick={props.onDeleteAvatar} icon={'icon-delete'} />
        </InputButton>
      )}
      {!props.isLoading && !hasAvatar && (
        <InputButton htmlFor="file">
          <Icon icon={props.image ? icon : 'icon-photo_camera'} />
        </InputButton>
      )}
    </Wrapper>
  );
}

export default AcAvatar;
